import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'Multi-Layer Fraud Prevention',
    title: 'Stop fake applicants and identity fraud',
    subtitle: 'A two-layer fraud engine combines agentic AI metadata forensics with multi-modal biometric identity binding \u2014 detecting bots, mass applications, AI-written resumes, and identity swaps before they reach your pipeline.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #5B2333 50%, #DC2626 100%)',
  },
  sections: [
    {
      label: 'Layer 1 \u2014 AI & Metadata Forensics',
      title: 'Catch bots and fabricated applications',
      features: [
        { icon: '\u26a1', title: 'Velocity Detection', desc: 'Flags bot-like application bursts, mass-spray patterns, and mechanically consistent timing intervals that signal automation.' },
        { icon: '\ud83c\udf10', title: 'IP Collision Analysis', desc: 'Detects multiple identities applying from a single IP address \u2014 a strong signal of coordinated fraud.' },
        { icon: '\ud83d\udcdd', title: 'Resume Forensics', desc: 'Scores content for thin or padded resumes, disposable email domains, duplicated phrasing, and AI-generated language density.' },
        { icon: '\ud83d\udce7', title: 'Contact Consistency', desc: 'Cross-checks the email in the resume against the application email to catch mismatches and impersonation.' },
      ],
      columns: 2,
    },
    {
      label: 'Layer 2 \u2014 Biometric Identity Binding',
      title: 'Verify the same person throughout',
      features: [
        { icon: '\u2328\ufe0f', title: 'Typing Signatures', desc: 'Builds a keystroke-dynamics signature during assessments and interviews to confirm a consistent author across sessions.' },
        { icon: '\ud83d\udc64', title: 'Face Presence Checks', desc: 'Multi-modal face-presence signals help confirm the candidate taking the assessment is the same one in the interview.' },
        { icon: '\ud83d\udd17', title: 'Identity Binding', desc: 'Links biometric signals across screening, assessment, and interview to detect identity swaps and proxy test-takers.' },
        { icon: '\ud83d\udcca', title: 'Combined Fraud Score', desc: 'Fuses Layer 1 and Layer 2 signals into a single, explainable risk score with evidence for every flag.' },
      ],
      columns: 2,
    },
    {
      label: 'For Compliance & Talent Teams',
      title: 'Trustworthy candidates, explainable decisions',
      desc: 'Every fraud signal comes with a severity, a human-readable detail, and the evidence behind it \u2014 so your team can act with confidence and defend decisions.',
      bullets: [
        'Real-time fraud dashboard across all applications',
        'Per-candidate fraud reports with itemized signals',
        'Severity levels: critical, high, medium, low',
        'Designed to reduce wasted interview time on fake applicants',
        'Works automatically as candidates apply and complete evaluations',
      ],
      visual: '\ud83d\udee1\ufe0f',
      visualLabel: 'Fraud Prevention Dashboard',
    },
  ],
  testimonial: {
    quote: 'We were drowning in bot applications and AI-written resumes. CHIRE\u2019s fraud engine cut the noise dramatically and flagged a proxy test-taker we would never have caught manually.',
    name: 'Anita V.',
    role: 'Compliance Lead, SecureHire',
  },
  cta: {
    title: 'Keep fraud out of your hiring funnel',
    desc: 'Two layers of AI-powered fraud prevention, working automatically. Get started with CHIRE.',
  },
};

export default function FraudPreventionPage() { return <ProductPageTemplate data={DATA} />; }
